import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../../Store/Actions/index";
import Spinner from "../UI/Spinner/Spinner";
import "./BookDetail.css";
import InputGroup from "react-bootstrap/InputGroup";
import paymentInfo from "../../assets/Images/group@2x.png";
import FormControl from "react-bootstrap/FormControl";
import { Row, Col, Button, Container } from "react-bootstrap";
import Success from "../../assets/Images/Success.svg";
import Footer from "../Footer/Footer";
import Breadcrumbs from "react-router-dynamic-breadcrumbs";
import { Link as Router } from "react-router-dom";
import amazonBtn from "../../assets/Images/amazon.png";
import googlePlay from "../../assets/Images/google-play-badge.png";
import flipkart from "../../assets/Images/flipkart.png";
class bookDetail extends Component {
  state = {
    pincode: null,
    delivaryCheck: false,
    addedToCart: false,
    medium: "",
    bookId: "",
    checkFunctionCall: false,
    routes: {
      "/": "Home",
      "/catalogue": "Catalogue",
      "/catalogue/:id": "",
      "/catalogue/:id/:bookname": this.props.match.params.bookname,
    },
  };
  componentDidMount() {
    this.props.getBookDetail(this.props.match.params.id);
    this.setState({
      delivaryCheck: false,
      checkFunctionCall: false,
      addedToCart: false,
    });
  }
  selectMedium(mediumID, type) {
    var btn1 = document.getElementById("btn1");
    var btn2 = document.getElementById("btn2");

    if (type === "one") {
      btn1.classList.add("focusBtn");
      btn2.classList.remove("focusBtn");
    } else {
      btn1.classList.remove("focusBtn");

      btn2.classList.add("focusBtn");
    }
    this.setState({
      medium: mediumID,
      checkFunctionCall: true,
      addedToCart: false,
    });
  }
  AddItemToCart = (id) => {
    var bookId = id;
    this.props.addItemToCartHandler(bookId);
    this.setState({
      addedToCart: true,
    });
  };

  addItemToCartWithMedium = () => {
    this.props.addItemToCartHandler(this.state.medium);
    this.setState({
      addedToCart: true,
    });
  };
  ISBNConverter = (isbn) => {
    var i;
    var k;
    var j = 0;
    var count = 10;
    var st = isbn.trim().substring(3, 12);
    for (i = 0; i < st.length; i++) {
      {
        k = parseInt(st.charAt(i) + "");
        j = j + k * count;
        count--;
      }
    }
    j = (11 - (j % 11)) % 11;
    if (j == 10) {
      j = "X";
    }
    document
      .getElementById("isbn")
      .setAttribute("href", "https://www.amazon.in/dp/" + st + j);
  };
  checkAvailability = (event) => {
    // const { name, value } = event.target;
    this.setState({
      [event.target.name]: event.target.value,
    });
  };
  delivaryDays = () => {
    let payload = {
      zipcode: this.state.pincode,
    };
    this.props.CheckPincode(payload);
    this.setState({
      delivaryCheck: true,
    });
  };
  render() {
  
    let about;
    if (this.props.bookDetail.length !== 0) {
      if (this.props.bookDetail[0].about !== "") {
        about = this.props.bookDetail[0].about;
        about = about.replace(/<.*?>/g, "");
        about = about.replace(/&nbsp;/g, " ");
      }
    }
    this.props.bookDetail.length > 0
      ? (document.title = `VK Global Publications |  Buy our latest editions of CBSE textbooks and exam preparation books | ${this.props.bookDetail[0].title}`)
      : (document.title =
          "VK Global Publications | Buy our latest editions of CBSE textbooks and exam preparation books");
    let component = this.props.loading ? (
      <Spinner />
    ) : this.props.bookDetail.length > 0 ? (
      <div>
        <div className="section2">
          <Container>
            <h3 className=" bookDetailCrumbs  cataloguebreadcrumbs float-right">
              <Router>
                <Breadcrumbs mappedRoutes={this.state.routes} />
              </Router>
            </h3>
            <h3 className="about-us ">
              {this.props.bookDetail[0].title} - class{" "}
              {this.props.bookDetail[0].class_name}
            </h3>
            <div className="box bookDetailBox">
              <Row>
                <Col sm={4}>
                  <div className="bookImage">
                    <img src={this.props.bookDetail[0].image} alt="book" />
                  </div>
                </Col>
                <Col sm={8}>
                  <div className="bookDetail">
                    <p className="title">{this.props.bookDetail[0].title}</p>
                    <p>Class - {this.props.bookDetail[0].class_name}</p>
                    {this.props.bookDetail[0].authors.length == 0 ? (
                      ""
                    ) : (
                      <p>
                        Author - {this.props.bookDetail[0].authors[0].authors}
                      </p>
                    )}
                    <p>Board - {this.props.bookDetail[0].board_name}</p>
                    <p>Edition - {this.props.bookDetail[0].edition}</p>
                    <p>
                      Medium - {this.props.bookDetail[0].medium_name}{" "}
                      {this.props.bookDetail.length > 1
                        ? "," + this.props.bookDetail[1].medium_name
                        : ""}
                    </p>
                    <p style={{ fontFamily: "SFUITextSemibold" }}>
                      Price - ₹ {this.props.bookDetail[0].price}
                    </p>

                    <br />
                    <p>
                      ISBN : - {this.props.bookDetail[0].isbn} (
                      {this.props.bookDetail[0].medium_name})
                    </p>
                    {this.props.bookDetail.length > 1 ? (
                      <p>
                        ISBN : - {this.props.bookDetail[1].isbn} (
                        {this.props.bookDetail[1].medium_name})
                      </p>
                    ) : (
                      ""
                    )}
                    <br />

                    {this.props.bookDetail.length > 1 ? (
                      <div className="info">
                        <p>Available in : </p>
                        <div id="myDIV" className="btn-container">
                          <button
                            id="btn1"
                            className="available btn focusBtn"
                            onClick={() => {
                              this.selectMedium(
                                this.props.bookDetail[0].bmid,
                                "one"
                              );
                            }}
                          >
                            ENGLISH - ₹ {this.props.bookDetail[0].price}
                          </button>
                          <button
                            id="btn2"
                            className="available btn"
                            onClick={() => {
                              this.selectMedium(
                                this.props.bookDetail[1].bmid,
                                "two"
                              );
                            }}
                          >
                            HINDI - ₹ {this.props.bookDetail[1].price}
                          </button>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    <p className="Delivery">Delivery :</p>
                    <InputGroup className="mb-3 customInput">
                      <FormControl
                        placeholder="Pin code"
                        aria-label="Recipient's username"
                        aria-describedby="basic-addon2"
                        name="pincode"
                        value={this.state.pincode}
                        onChange={this.checkAvailability}
                        disabled={this.props.pincodeLoading}
                      />
                      <InputGroup.Append>
                        <Button
                          variant="outline-secondary customInputButtom"
                          onClick={this.delivaryDays}
                          disabled={this.props.pincodeLoading}
                        >
                          Check
                        </Button>
                      </InputGroup.Append>
                      {this.state.delivaryCheck ? (
                        <p className="delivary">
                          {this.props.outsideIndiaDelivary
                            ? "Usually delivered in 3 days"
                            : "Usually delivered in 7 days"}
                        </p>
                      ) : (
                        ""
                      )}
                      {this.props.pincodeLoading ? (
                        <span>
                          <Spinner />
                        </span>
                      ) : null}
                    </InputGroup>
                    <button
                      className= {  this.props.bookDetail[0].pre_order === null ? "buy" : "preorder"} 
                      onClick={
                        this.state.checkFunctionCall
                          ? this.addItemToCartWithMedium
                          : () =>
                              this.AddItemToCart(this.props.bookDetail[0].bmid)
                      }
                    >
                    {
                       this.props.bookDetail[0].pre_order === null ? "ADD TO CART" : 'PRE-ORDER'  
                    } <i className="icon dripicons-cart"></i>
                    </button>
                    {this.state.addedToCart ? (
                      <span className="added">
                        <img
                          className="text-center"
                          width="20"
                          height="20"
                          src={Success}
                          alt="book"
                        />
                        <span>Added</span>
                      </span>
                    ) : (
                      ""
                    )}
                    {this.props.bookDetail[0].about !== "" ? (
                      <div className="aboutBook">
                        <h3>About the Book</h3>
                        <p>{about}</p>
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="availableOn">
                      <p>Also Available on : </p>
                      <a
                        id="isbn"
                        href=""
                        target="_blank"
                        onClick={() =>
                          this.ISBNConverter(this.props.bookDetail[0].isbn)
                        }
                      >
                        <img height="48" src={amazonBtn} />
                      </a>
                      {this.props.bookDetail[0].google_play_link !== null &&
                      this.props.bookDetail[0].google_play_link !== "" &&
                      this.props.bookDetail[0].google_play_link !== "N/A" ? (
                        <a
                          target="_blank"
                          href={this.props.bookDetail[0].google_play_link}
                        >
                          <img className="google" src={googlePlay} />
                        </a>
                      ) : null}
                      {this.props.bookDetail[0].flipkart_link !== null &&
                      this.props.bookDetail[0].flipkart_link !== "" &&
                      this.props.bookDetail[0].flipkart_link !== "N/A" ? (
                        <a
                          target="_blank"
                          href={this.props.bookDetail[0].flipkart_link}
                        >
                          <img className="google" src={flipkart} />
                        </a>
                      ) : null}
                    </div>
                    <div className="BookDetailTransaction">
                      <p>We Accept</p>
                      <img src={paymentInfo} alt="book" />
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
          <Footer />
        </div>
      </div>
    ) : (
      ""
    );

    return <div>{component}</div>;
  }
}

const mapStateToProps = (state) => {
  return {
    books: state.book.books,
    loading: state.book.loading,
    bookDetail: state.book.bookDetail,
    cartBook: state.book.addedBooks,
    outsideIndiaDelivary: state.book.outsideIndiaDelivary,
    pincodeLoading: state.book.pincodeLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getBookDetail: (id) => dispatch(actions.fetchBookDetail(id)),
    addItemToCartHandler: (id) => dispatch(actions.addItemToCart(id)),
    CheckPincode: (pincode) => dispatch(actions.CheckPincode(pincode)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(bookDetail);
